<template>
    <v-container>
        <v-row class="justify-start">
            <v-col cols="6" v-if="userInfo.fbUser !== null">
                <v-subheader>Dashboard</v-subheader>
                <v-subheader>{{ userInfo.fbUser.displayName }}</v-subheader>
                <v-subheader>{{ userInfo.fbUser.uid }}</v-subheader>
                <v-subheader>{{ userInfo.fbUser.email }}</v-subheader>
                <v-subheader>{{ userInfo.fbUser.emailVerified }}</v-subheader>
            </v-col>
        </v-row>
        <v-spacer />
        <v-container fluid grid-list-sm>
            <v-layout class="fill-height" />
        </v-container>
    </v-container>
</template>

<script>
export default {
    name: 'dashboard',
    data() {
        return {};
    },
    computed: {
        userInfo() {
            return this.$store.state.user;
        }
    }
};
</script>
